import { useQuery } from "@tanstack/react-query";
import { calendarApi, type CalendarUpcoming } from "@/api/endpoints/calendar";

export const CALENDAR_KEYS = {
  upcoming: (windowHours: number, limit: number) =>
    ["calendar", "upcoming", windowHours, limit] as const,
};

export function useUpcomingCalendar(options?: {
  windowHours?: number;
  limit?: number;
  enabled?: boolean;
}) {
  const windowHours = options?.windowHours ?? 168;
  const limit = options?.limit ?? 50;
  return useQuery<CalendarUpcoming>({
    queryKey: CALENDAR_KEYS.upcoming(windowHours, limit),
    queryFn: () => calendarApi.listUpcoming(windowHours, limit),
    enabled: options?.enabled ?? true,
    // Backend caches for 60 s; mirror that on the client so we don't refetch
    // on every navigation, but still pick up new events within a minute.
    staleTime: 60_000,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
    retry: 1,
  });
}
